window.addEventListener("load", function () {
  var swiper = new Swiper(".mobile-swiper", {
    //loop: true,
  });

  // let elem = document.querySelector(".loop");
  // let infScroll = new InfiniteScroll(elem, {
  //   // options
  //   path: ".next",
  //   append: ".product",
  //   history: false,
  // });

  const loop = document.querySelector(".loop");
  const nextBtn = document.querySelector("#next-btn");
  let nextUrl = nextBtn?.getAttribute("href");
  let loading = false;

  if (loop && nextUrl) {
    const trigger = document.createElement("div");
    trigger.id = "scroll-trigger";
    trigger.style.height = "1px";
    loop.parentNode.insertBefore(trigger, loop.nextSibling);

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: "#scroll-trigger",
      triggerHook: 1,
    })
      .addTo(controller)
      .on("enter", function () {
        if (!loading && nextUrl) {
          loading = true;
          fetchNextPage(nextUrl);
        }
      });
  }

  function fetchNextPage(url) {
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelectorAll(".product");
        const newNextBtn = doc.querySelector("#next-btn");

        newProducts.forEach((product) => {
          loop.appendChild(product);
        });

        nextUrl = newNextBtn ? newNextBtn.getAttribute("href") : null;

        // Remove .next if no more pages
        if (!nextUrl) {
          document.querySelector(".next")?.remove();
        }

        loading = false;
      })
      .catch((err) => {
        console.error("ScrollMagic fetch error:", err);
        loading = false;
      });
  }




  let loopCon = document.querySelector(".loop");

  let sizeBtn = document.querySelectorAll(".size-btn");
  sizeBtn.forEach(function(item, index){
    item.addEventListener("click", function(event){
      event.preventDefault();
      if(index == 0){
        sizeBtn[0].classList.add("active");
        sizeBtn[1].classList.remove("active");
        loopCon.classList.remove("large");
      } else {
        sizeBtn[0].classList.remove("active");
        sizeBtn[1].classList.add("active");
        loopCon.classList.add("large");
      }
    });
  });

  // let stockBtn = document.querySelectorAll(".stock-btn");
  // stockBtn.forEach(function(item, index){
  //   item.addEventListener("click", function(event){
  //     event.preventDefault();
  //     if(index == 0){
  //       stockBtn[0].classList.add("active");
  //       stockBtn[1].classList.remove("active");
  //       loopCon.classList.remove("in-stock");
  //     } else {
  //       stockBtn[0].classList.remove("active");
  //       stockBtn[1].classList.add("active");
  //       loopCon.classList.add("in-stock");
  //     }
  //   });
  // });
  
});
